module.exports = __webpack_public_path__ + "static/media/h-billpayment.d1fffd77.png";